import styled from "styled-components";

export const LiveCasinoFilterButtonIconDefaultBox = styled.div<{isActiveTab?: boolean}>`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 5em;
    width: 100%;
    color: ${({theme, isActiveTab}) => isActiveTab ? theme.colors.brandSecondary : theme.colors.bodyText};
    transform: scale(${({isActiveTab}) => isActiveTab ? 1 : 0.8});
    transition: transform 0.25s ease;

    :hover {
        transform: scale(1);
    }
`;